import React, { Component } from 'react';
import axios from 'axios';
import { FormGroup, Input, Label } from 'reactstrap';

class AdminSingleDefinition extends Component {

    state = {
        value: ""
    }

    getDefinition = () => {

        axios.get(`/api/admin-settings/${this.props.db}`).then(res => {
            if (res.data.data.length !== 0) {
                let value = res.data.data[0].value;
                if (this.props.strField) {
                    value = res.data.data[0].valueStr;
                }
                this.setState({
                    value: value
                })
            }
        })

    }

    setDefinition = (newValue) => {

        let url = `/api/admin-settings/${this.props.db}`
        if (this.props.strField) {
            url = `/api/admin-settings/str/${this.props.db}`
        }

        axios.post(url, {
            value: newValue
        }, {
            headers: {
                'Authorization': "Token " + localStorage.getItem('authToken')
            }
        }).then(res => {

        })

    }

    onInputChange = (e) => {

        this.setState({
            value: e.target.value
        })

        this.setDefinition(e.target.value);

    }

    componentDidMount() {
        this.getDefinition();
    }

    render() {
        return (
            <FormGroup>
                <Label for={this.props.db}>{this.props.name}</Label>
                <Input
                    type="text"
                    name={this.props.db}
                    id={this.props.db}
                    placeholder={this.props.name}
                    defaultValue={this.state.value}
                    onBlur={this.onInputChange}
                />
            </FormGroup>
        );
    }

}

export default AdminSingleDefinition;



// WEBPACK FOOTER //
// ./src/components/AdminSingleDefinition.js